import * as API from 'common/constant/routes'
import { getJson, postJson, putFile } from 'helper/http'
import toSnakeCase from '@deliverance-ai/map-keys-case/to-snake-case'

export const getDiscoveries = (sort, direction, limit, start) => getJson(API.GET_DISCOVERIES, {}, toSnakeCase({ direction, limit, sort, start }))
export const addNewDiscovery = (discoveryObject) => postJson(API.ADD_DISCOVERY, {}, { ...discoveryObject })
export const editDiscovery = (discoveryObject) => postJson(API.EDIT_DISCOVERY, {}, { ...discoveryObject })
export const uploadFile = (url, file) => putFile(url, file, file.type)
export const searchDiscoveries = (searchTerm, sort, direction, limit, start) => getJson(API.SEARCH_DISCOVERIES, {}, toSnakeCase({ direction, limit, searchTerm, sort, start }))
export const downloadDiscoveries = (columns) => postJson(API.DOWNLOAD_DISCOVERIES, {}, { columns })
